/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { setTlsCertificateUrl } from '@modules/cloud-api/v1/urls'
import type { RegionId } from '@modules/ui-types'

import asyncRequest, { resetAsyncRequest } from '../asyncRequests'
import { UPLOAD_TLS_CERTIFICATE } from '../../constants/actions'

export function uploadTlsCertificate(regionId: RegionId, certificateType: string, chain: string) {
  const url = setTlsCertificateUrl({ regionId, serviceName: certificateType })

  return asyncRequest({
    type: UPLOAD_TLS_CERTIFICATE,
    url,
    method: `POST`,
    requestSettings: {
      json: false,
    },
    payload: chain,
    meta: { regionId, certificateType, chain: [chain] },
    crumbs: [regionId, certificateType],
  })
}

export const resetUploadTlsCertificateRequest = (...crumbs) =>
  resetAsyncRequest(UPLOAD_TLS_CERTIFICATE, crumbs)
